import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { routing } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { DataTablesModule } from 'angular-datatables';
import { NgbdModalContent } from '../app/servicios/loader/formatoloader.component';
import { LoaderComponent } from '../app/servicios/loader/loader.component';


import { ToolsService } from './recursos/tools.service';
import { AlertifyService } from './recursos/alertify.service';
import { configuracion } from './recursos/config.service';

import { SeleccionService } from './servicios/seleccion.service';
import { recursosBecas } from './recursos/interfaz';
import { AuthHelper } from '../authHelper/authHelper';
import { CasClient } from 'src/app/casClient/CasClient';
import { HttpService } from 'src/app/casClient/http.service';

import { from } from 'rxjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { BodyPublicComponent } from './publico/body-public/body-public.component';
import { FooterPublicComponent } from './publico/footer-public/footer-public.component';
import { HeaderPublicComponent } from './publico/header-public/header-public.component';
import { PrincipalPublicComponent } from './publico/principal-public/principal-public.component';
import { IngresoPublicComponent } from './publico/ingreso-public/ingreso-public.component';

import { BodyAdminComponent } from './administrar/body-admin/body-admin.component';
import { PrincipalAdminComponent } from './administrar/principal-admin/principal-admin.component';
import { HeaderAdminComponent } from './administrar/header-admin/header-admin.component';
import { FooterAdminComponent } from './administrar/footer-admin/footer-admin.component';
import { SliderAdminComponent } from './administrar/slider-admin/slider-admin.component';
import { ContentAdminComponent } from './administrar/content-admin/content-admin.component';
import { UsuariosAdminComponent } from './administrar/usuarios-admin/usuarios-admin.component';
import { RolesAdminComponent } from './administrar/roles-admin/roles-admin.component';
import { EstadosAdminComponent } from './administrar/estados-admin/estados-admin.component';
import { PermisoCrearAdminComponent } from './administrar/permiso-crear-admin/permiso-crear-admin.component';
import { PermisoAsignaAdminComponent } from './administrar/permiso-asigna-admin/permiso-asigna-admin.component';
import { ModulosAdminComponent } from './administrar/modulos-admin/modulos-admin.component';

import { HeraderOperarioComponent } from './operario/herader-operario/herader-operario.component';
import { SliderOperarioComponent } from './operario/slider-operario/slider-operario.component';
import { BodyOperarioComponent } from './operario/body-operario/body-operario.component';
import { FooterOperarioComponent } from './operario/footer-operario/footer-operario.component';
import { ContentOperarioComponent } from './operario/content-operario/content-operario.component';
import { PrincipalOperarioComponent } from './operario/principal-operario/principal-operario.component';
import { ReqGeneralOperarioComponent } from './operario/req-general-operario/req-general-operario.component';
import { ReqEspecificoOperarioComponent } from './operario/req-especifico-operario/req-especifico-operario.component';
import { BecasTipoOperarioComponent } from './operario/becas-tipo-operario/becas-tipo-operario.component';
import { RequisitoTipoOperarioComponent } from './operario/requisito-tipo-operario/requisito-tipo-operario.component';
import { BecasDetalleOperarioComponent } from './operario/becas-detalle-operario/becas-detalle-operario.component';
import { CalificacionesOperarioComponent } from './operario/calificaciones-operario/calificaciones-operario.component';
import { ReqEspecificoOperarioVerComponent } from './operario/req-especifico-operario-ver/req-especifico-operario-ver.component';
import { ReqGeneralOperarioVerComponent } from './operario/req-general-operario-ver/req-general-operario-ver.component';
import { ListaBecariosComponent } from './operario/lista-becarios/lista-becarios.component';
import { PromedioOperarioComponent } from './operario/promedio-operario/promedio-operario.component';
import { EncuestaRespuestaComponent } from './operario/encuesta-respuesta/encuesta-respuesta.component';
import { EncuestaListaRespondeComponent } from './operario/encuesta-lista-responde/encuesta-lista-responde.component';
import { EncuestaPreguntaComponent } from './operario/encuesta-pregunta/encuesta-pregunta.component';
import { EncuestaGrupoComponent } from './operario/encuesta-grupo/encuesta-grupo.component';
import { EncuestaComponent } from './operario/encuesta/encuesta.component';
import { EncuestaMatrizComponent } from './operario/encuesta-matriz/encuesta-matriz.component';
import { EncuestaReporteComponent } from './operario/encuesta-reporte/encuesta-reporte.component';
import { SimuladorAdminARComponent } from './operario/simulador-admin-ar/simulador-admin-ar.component';
import { EducativaConsultasComponent } from './operario/educativa-consultas/educativa-consultas.component';
import { EducativaReservaComponent } from './operario/educativa-reserva/educativa-reserva.component';
import { EducativaInfAtencionesComponent } from './operario/educativa-inf-atenciones/educativa-inf-atenciones.component';
import { EncuestaMatrizResultadoComponent } from './operario/encuesta-matriz-resultado/encuesta-matriz-resultado.component';
import { Calificaciones23OperarioComponent } from './operario/calificaciones23-operario/calificaciones23-operario.component';
import { SimuladorAR2023ComponentComponent } from './operario/simulador-ar2023-component/simulador-ar2023-component.component';
import { EstudioSocioEconomicoComponent } from './operario/estudio-socio-economico/estudio-socio-economico.component';
import { EducativaReservaListaComponent } from './operario/educativa-reserva-lista/educativa-reserva-lista.component';

import { HeaderBecarioComponent } from './becario/header-becario/header-becario.component';
import { FooterBecarioComponent } from './becario/footer-becario/footer-becario.component';
import { BodyBecarioComponent } from './becario/body-becario/body-becario.component';
import { SliderBecarioComponent } from './becario/slider-becario/slider-becario.component';
import { PrincipalBecarioComponent } from './becario/principal-becario/principal-becario.component';
import { ContentBecarioComponent } from './becario/content-becario/content-becario.component';
import { VerBecasBecarioComponent } from './becario/ver-becas-becario/ver-becas-becario.component';
import { VerRequisitoBecarioComponent } from './becario/ver-requisito-becario/ver-requisito-becario.component';
import { PostulaBecarioComponent } from './becario/postula-becario/postula-becario.component';
import { PostulaVerBecarioComponent } from './becario/postula-ver-becario/postula-ver-becario.component';
import { FichaEstudianteComponent } from './becario/ficha-estudiante/ficha-estudiante.component';
import { FichaListaComponent } from './becario/ficha-lista/ficha-lista.component';
import { FichaRespuestaComponent } from './becario/ficha-respuesta/ficha-respuesta.component';
import { FichaEditarComponent } from './becario/ficha-editar/ficha-editar.component';

import { recursosCompartido } from './recursos/cosumoGeneral.service';
import { TipoBecaAjusteComponent } from './operario/tipo-beca-ajuste/tipo-beca-ajuste.component';
import { EstudioSocioEcRevisaComponent } from './operario/estudio-socio-ec-revisa/estudio-socio-ec-revisa.component';
import { Calificaciones24OperarioComponent } from './operario/calificaciones24-operario/calificaciones24-operario.component';
import { EstudioSocioEcListaComponent } from './operario/estudio-socio-ec-lista/estudio-socio-ec-lista.component';
import { Calificaciones25Component } from './operario/calificaciones25/calificaciones25.component';
import { SimuladorAr2025Component } from './operario/simulador-ar2025/simulador-ar2025.component';
import { EstudioSocioEconomico2025Component } from './operario/estudio-socio-economico2025/estudio-socio-economico2025.component';
import { FichaCustionariosComponent } from './operario/ficha-custionarios/ficha-custionarios.component';
import { FichaPreguntasComponent } from './operario/ficha-preguntas/ficha-preguntas.component';
import { FichaRespondeEstudianteComponent } from './becario/ficha-responde-estudiante/ficha-responde-estudiante.component';
import { EncuestaListaFaltantesComponent } from './operario/encuesta-lista-faltantes/encuesta-lista-faltantes.component';

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    NgbdModalContent,
    BodyPublicComponent,
    FooterPublicComponent,
    HeaderPublicComponent,
    PrincipalPublicComponent,
    IngresoPublicComponent,
    BodyAdminComponent,
    PrincipalAdminComponent,
    HeaderAdminComponent,
    FooterAdminComponent,
    SliderAdminComponent,
    ContentAdminComponent,
    UsuariosAdminComponent,
    RolesAdminComponent,
    EstadosAdminComponent,
    PermisoCrearAdminComponent,
    PermisoAsignaAdminComponent,
    ModulosAdminComponent,
    HeraderOperarioComponent,
    SliderOperarioComponent,
    BodyOperarioComponent,
    FooterOperarioComponent,
    ContentOperarioComponent,
    PrincipalOperarioComponent,
    ReqGeneralOperarioComponent,
    ReqEspecificoOperarioComponent,
    BecasTipoOperarioComponent,
    RequisitoTipoOperarioComponent,
    BecasDetalleOperarioComponent,
    CalificacionesOperarioComponent,
    HeaderBecarioComponent,
    FooterBecarioComponent,
    BodyBecarioComponent,
    SliderBecarioComponent,
    PrincipalBecarioComponent,
    ContentBecarioComponent,
    VerBecasBecarioComponent,
    VerRequisitoBecarioComponent,
    ReqEspecificoOperarioVerComponent,
    ReqGeneralOperarioVerComponent,
    ListaBecariosComponent,
    PostulaBecarioComponent,
    PostulaVerBecarioComponent,
    PromedioOperarioComponent,
    EducativaConsultasComponent,
    EducativaReservaComponent,
    EducativaInfAtencionesComponent,
    EncuestaPreguntaComponent,
    EncuestaGrupoComponent,
    EncuestaComponent,
    FichaEstudianteComponent,
    FichaListaComponent,
    FichaRespuestaComponent,
    EncuestaRespuestaComponent,
    EncuestaListaRespondeComponent,
    FichaEditarComponent,
    EncuestaMatrizComponent,
    EncuestaReporteComponent,
    SimuladorAdminARComponent,
    EncuestaMatrizResultadoComponent,
    Calificaciones23OperarioComponent,
    SimuladorAR2023ComponentComponent,
    EstudioSocioEconomicoComponent,
    EducativaReservaListaComponent,
    TipoBecaAjusteComponent,
    EstudioSocioEcRevisaComponent,
    Calificaciones24OperarioComponent,
    EstudioSocioEcListaComponent,
    Calificaciones25Component,
    SimuladorAr2025Component,
    EstudioSocioEconomico2025Component,
    FichaCustionariosComponent,
    FichaPreguntasComponent,
    FichaRespondeEstudianteComponent,
    EncuestaListaFaltantesComponent
  ],
  entryComponents: [NgbdModalContent],
  imports: [
    BrowserModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    HttpModule,
    routing,
    NgbModule.forRoot(),
    DataTablesModule
  ],
  providers: [AlertifyService, AuthHelper, SeleccionService, recursosBecas, configuracion, LoaderComponent, ToolsService, CasClient, HttpService, recursosCompartido],
  bootstrap: [AppComponent]
})
export class AppModule { }
